import { formatQuantity } from "components/helpers/format";
import React from "react";
import styled, { useTheme } from "styled-components";

const ProgressBar = styled.div(({ theme }) => ({
  backgroundColor: theme.colors.lightGrey,
  borderRadius: "3px",
  gridColumn: "2 / 2",
  height: "6px",
  margin: "4px 0",
}));

const Progress = styled.span`
  display: block;
  width: ${({ producedProgressBarWidth }) => `${producedProgressBarWidth}%`};
  height: 100%;
  border-radius: 3px;
  background-color: ${({ producedProgressBarColor }) => producedProgressBarColor};
`;

function calculateProgressBarWidth(workOrder) {
  const { producedQuantity, quantity } = workOrder;

  if (!producedQuantity || !quantity) return 0;

  const roundedProducedQuantity = formatQuantity(producedQuantity);
  const roundedQuantity = formatQuantity(quantity);
  const producedPercentage = Math.floor((roundedProducedQuantity / roundedQuantity) * 100);

  return Math.min(producedPercentage, 100);
}

function calculateProgressBarColor(workOrder, producedProgressBarWidth, theme) {
  const { missingData } = workOrder;

  if (producedProgressBarWidth >= 100) return theme.colors.green;
  if (missingData) return theme.colors.midGrey;

  return theme.colors.blue;
}

export default function ProductionProgressBar({ workOrder }) {
  const theme = useTheme();
  const producedProgressBarWidth = calculateProgressBarWidth(workOrder);
  const producedProgressBarColor = calculateProgressBarColor(workOrder, producedProgressBarWidth, theme);

  return (
    <ProgressBar>
      <Progress
        data-testid="progress"
        producedProgressBarColor={producedProgressBarColor}
        producedProgressBarWidth={producedProgressBarWidth}
      />
    </ProgressBar>
  );
}
